import { ButtonBase, Typography } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import React from 'react'
import { useLocation } from 'react-router-dom'

import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { RatePlanBrief } from '../../types/rateplan'
import useStyles from './styles/RateplansTable.styles'

interface RatePlanRowProps {
  data: RatePlanBrief
  roomTypeid: string
  roomTypeName: string
  hasAccessToViewRatePlanTabs: boolean | undefined
  isRoleAdmin: boolean
}

const RatePlanRow: React.FC<RatePlanRowProps> = ({
  data,
  roomTypeid,
  roomTypeName,
  hasAccessToViewRatePlanTabs,
  isRoleAdmin
}) => {
  const classes = useStyles()
  const location = useLocation()

  const {
    name,
    displayRatePlanCode,
    numberOfRates,
    displayRoomTypeCode,
    boardType,
    type,
    id,
    providerCode,
    providerName,
    deleted,
    active
  } = data

  const checkIcon = (input: boolean) => {
    if (input) {
      return <CheckIcon />
    }
  }

  return (
    <div
      className={[
        classes.tableRowRoot,
        isRoleAdmin ? classes.tableRowRootAdmin : ''
      ].join(' ')}>
      <ButtonBase
        className={[
          classes.tableRow,
          isRoleAdmin ? classes.tableRowAdmin : ''
        ].join(' ')}
        component={LocalizedLink}
        to={
          hasAccessToViewRatePlanTabs
            ? `${location.pathname
                .replace('/list', '')
                .replace('/rate-plans', '')
                .replace('/en', '')
                .replace(
                  '/fa',
                  ''
                )}/room-type/${roomTypeid}/rate-plans/${id}/providerCode/${providerCode}/details`
            : ''
        }>
        <div className={classes.nameCell}>
          <Typography variant="h4">{name}</Typography>
        </div>
        <div>
          <Typography variant="body1">{displayRatePlanCode}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate(type)}</Typography>
        </div>
        <div>
          <Typography variant="body1">{`${roomTypeName} (${displayRoomTypeCode})`}</Typography>
        </div>
        <div>
          <Typography variant="body1">{numberOfRates}</Typography>
        </div>
        <div>
          <Typography variant="body1">{boardType}</Typography>
        </div>
        <div>
          <Typography variant="body1">{providerName}</Typography>
        </div>
        {isRoleAdmin && (
          <>
            <div>{checkIcon(deleted)}</div>
            <div>{checkIcon(!active)}</div>
          </>
        )}
      </ButtonBase>
    </div>
  )
}

export default RatePlanRow
